import React from 'react';
import { Shield, AlertTriangle, CheckCircle } from 'lucide-react';

const PaymentModeIndicator = ({ 
  mode = "test", // "test" or "live"  
  className = "",
  size = "sm" // "sm", "md", "lg"
}) => {
  const isLive = mode === "live";
  
  const sizeClasses = {
    sm: "text-xs px-2 py-1",
    md: "text-sm px-3 py-1", 
    lg: "text-base px-4 py-2"
  };
  
  const iconSizes = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5"
  };

  return (
    <div className={`inline-flex items-center rounded-full font-medium ${
      isLive 
        ? 'bg-green-100 text-green-800 border border-green-200' 
        : 'bg-amber-100 text-amber-800 border border-amber-200'
    } ${sizeClasses[size]} ${className}`}>
      {isLive ? (
        <CheckCircle className={`${iconSizes[size]} mr-1`} />
      ) : (
        <AlertTriangle className={`${iconSizes[size]} mr-1`} />
      )}
      {isLive ? 'LIVE PAYMENTS' : 'TEST MODE'}
    </div>
  );
};

export default PaymentModeIndicator;